import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { WEB_BODY1_CLASS } from '@riotgames/accounts-react-components/lib/Typography';
import { Grid, GridDirection } from '@riotgames/accounts-react-components/lib/Grid';
import './accountsList.scss';

const TYPO_ACC_TYPE = {
  LOCKED: {
    label: '해제',
    text: '(임시비활성화)'
  },
  ARCHIVED: {
    label: '휴면풀기',
    text: '(휴면)'
  },
  ENABLED: {
    label: '로그인',
    text: ''
  }
};

const AccountsList = ({ metrics }) => {
  const accounts = metrics.map((acc) => {
    const classes = cx({
      'state-locked': acc.accountState === 'LOCKED',
      'state-archived': acc.accountState === 'ARCHIVED',
      'state-enabled': acc.accountState === 'ENABLED'
    });

    return (
      <li key={acc.userName} className={classes}>
        <span className="account-name">
          {acc.userName} {TYPO_ACC_TYPE[acc.accountState].text}
        </span>
      </li>
    );
  });

  return (
    <Grid direction={GridDirection.vertical}>
      <ul className={cx(WEB_BODY1_CLASS, 'accounts-list')}>{accounts}</ul>
    </Grid>
  );
};

AccountsList.propTypes = {
  metrics: PropTypes.array
};

AccountsList.defaultProps = {
  metrics: []
};

export default AccountsList;
